import { isInAndroid } from '../../is-in-android';
import { autoWebViewJs } from '../../AutoWebViewJs';
import { ICallAndroidReslt } from '../../WebViewJs';

interface IA11yServiceLiveInfo {
  hasPermission?: boolean;
  hasService?: boolean;
  isAlive?: boolean;
  pingTime?: number;
  crashed?: boolean;
}

function getA11yServiceLiveInfo(): ICallAndroidReslt<IA11yServiceLiveInfo> {
  const script = `var info =com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceLiveInfo;\n var s = com.fanfanlo.lib.utils.JsonUtil.gson2.toJson(info);\n s;`;
  const info = autoWebViewJs.callScript<IA11yServiceLiveInfo>(script);
  return info;
}

function hasPermission():boolean{
    if(!isInAndroid())return false
    const res = autoWebViewJs.onCallGetA11yPermission<boolean>()
    // console.log('hasPermission', res)
    return res.javaResultData as boolean

    // return getA11yServiceLiveInfo().javaResultData?.hasPermission;
}

function openPermission(){
    autoWebViewJs.onCallOpenA11yPermission()
    // return autoWebViewJs.callScriptRunner(`com.fanfanlo.lib.permissions.FloatPermission.openPermission();`);

}
const hasPermissionScript = `var bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasServicePermission(com.fanfanlo.lib.mc.LibMainModel.Companion.instance.application, com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass.class);\nbl;`
function checkPermission(){
    //com.fanfanlo.lib.utils.ClassUtils.kclassToClass
    // let s = `val bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasServicePermission(com.fanfanlo.lib.mc.LibMainModel.libMainModel.application, com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass.java);\nbl;`
    // let s = `var bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasPermission(com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.getServiceJavaClass());\nbl;`
    // let s = `var bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasPermission(com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass);\nbl;`
    // let s = `var bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasServicePermission(com.fanfanlo.lib.mc.libMainModel.application, com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass.class);\nbl;`
    // let s = `var bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasServicePermission(com.fanfanlo.lib.mc.LibMainModel.Companion.instance.application, com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass.class);\nbl;`
    // let s = `var bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasServicePermission(com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass.class);\nbl;`
    // s = `var x = com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass;\nx`
    // let s = `var c = com.fanfanlo.lib.utils.ClassUtils.Companion.kclassToClass(com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceKClass);
    // var bl = com.fanfanlo.droidlib.auto.service.accessibility.a11yUtils.hasServicePermission(com.fanfanlo.lib.mc.libMainModel.application, c);
    // bl;`
        const res = autoWebViewJs.callScript<boolean>(hasPermissionScript)
        // console.log('checkPermission2222', res)
        return res
}
export const a11yScript = {
  getA11yServiceLiveInfo,
  hasPermission,
  openPermission,
  checkPermission,
  hasPermissionScript,
}